import jquery from 'jquery';
import 'bootstrap';

jquery(($) => {
  $('[data-toggle="tooltip"]').tooltip();
});
